import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import { Authorization } from './infrastructure/Authorization';
import registerCsrfInterceptor from './infrastructure/CsrfInterceptor'

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const renderApp = () => {
    ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>,
        rootElement);
}

if (process.env.NODE_ENV === 'development') {
    renderApp();
}
else {
    Authorization
        .Authorize()
        .then(() => {
            renderApp();
        })
        .catch(error => {
            console.log(error);
            Authorization.NavigateToLogin();
        });
}

registerCsrfInterceptor();

unregisterServiceWorker();

